import React from 'react'

import Button from '@mui/material/Button'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import { buttonStyling } from './menuStyles'

interface NavMenuButtonProps {
  children: React.ReactNode | string | undefined
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const NavMenuButton = (props: NavMenuButtonProps): JSX.Element => {
  return (
    <Button endIcon={<KeyboardArrowDownIcon />} onClick={props.onClick} sx={buttonStyling} color="inherit">
      {props.children}
    </Button>
  )
}

export default NavMenuButton
